import { FederalWithHoldingStatus } from '@app/model/enum/FederalWithHoldingStatus';
import { IServicePersonalInformation } from '@app/model/interfaces/IServicePersonalInformation';
import { IFederalInfo } from '../interfaces/IFederalInfo';

export class FederalInfo implements IFederalInfo{
  aditionallWithholdingAmount: number;
  allowances: number;
  deductionsAmount: number;
  isExempt: boolean;
  otherDependentsAmount: number;
  otherDependentsCount: number;
  otherIncomeAmount: number;
  qualifiedChildrenAmount: number;
  qualifiedChildrenCount: number;
  totalClaimAmount: number;
  twoJobsTotal: boolean;
  withHoldingStatus: FederalWithHoldingStatus;

  constructor(info: IServicePersonalInformation) {
    this.aditionallWithholdingAmount = info.federalAdditionallWithholdingAmount;
    this.allowances = info.federal_allowances;
    this.deductionsAmount = info.federalDeductionsAmount;
    this.isExempt = info.federalExempt;
    this.otherDependentsAmount = info.federalOtherDependentsAmount;
    this.otherDependentsCount = info.federalOtherDependentsCount;
    this.otherIncomeAmount = info.federalOtherIncomeAmount;
    this.qualifiedChildrenAmount = info.federalQualifiedChildrenAmount;
    this.qualifiedChildrenCount = info.federalQualifiedChildrenCount;
    this.totalClaimAmount = info.federalTotalClaimAmount;
    this.twoJobsTotal = info.federalTwoJobsTotal;
    switch (info.federalWithholding) {
      case 'MARRIED':
        this.withHoldingStatus = FederalWithHoldingStatus.MarriedFillingJointly;
        break;
      case 'HEAD':
        this.withHoldingStatus = FederalWithHoldingStatus.HeadOfHousehold;
        break;
      case 'SINGLE':
        this.withHoldingStatus = FederalWithHoldingStatus.SingleOrMarriedFillingSeparately;
        break;
      default:
        this.withHoldingStatus = FederalWithHoldingStatus.None;
    }
  }
}
